import * as Yup from "yup";

export const getRegisterSurveySchema = (isRequired) =>
  Yup.object().shape({
    name: isRequired
      ? Yup.string()
          .trim()
          .required("First name is required")
          .min(1, "First name must be at least 1 character")
          .max(100, "First name must not exceed 100 characters")
      : Yup.string(),

    lastName: isRequired
      ? Yup.string()
          .trim()
          .required("Last name is required")
          .min(1, "Last name must be at least 1 character")
          .max(100, "Last name must not exceed 100 characters")
      : Yup.string(),

    ageGroup: Yup.string().required("Age group is required"),

    email: isRequired
      ? Yup.string()
          .required("Email is required")
          .max(100, "Email must not exceed 100 characters")
          .test(
            "is-valid-email",
            "Invalid email address",
            (value) => !!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          )
      : Yup.string(),

    // ownsHouse: Yup.string().required("Ownership status is required"),

    currentCountry: Yup.number().required("Country selection is required"),

    familyMemberIds: Yup.array()
      .min(1, "At least one option must be selected")
      .required("Family members info is required"),

    passportHold: Yup.array()
      .min(1, "At least one option must be selected")
      .required("Passport information is required"),

    preferredLocationIds: Yup.array()
      .min(1, "At least one property preference must be selected")
      .required("Property preferences are required"),

    noPropertiesLikeToOwn: Yup.string().required("Property count is required"),

    healthPriority: Yup.string().required("Health care preference is required"),

    dayToDay: Yup.array()
      .min(1, "At least one activity must be selected")
      .required("Activities are required"),

    taxFreeCountry: Yup.string().required("Tax preference is required"),

    countriesLikeToLiveIds: Yup.array()
      .min(1, "At least one country preference must be selected")
      .required("Country preferences are required"),

    visaFreeCountry: Yup.string().required("Visa preference is required"),

    interestedCitizenshipId: Yup.number().nullable(),

    travelDistanceHoliday: Yup.number().required(
      "Holiday preference is required"
    ),

    travelDistanceLovedOnes: Yup.number().required(
      "Loved ones distance preference is required"
    ),

    minBudget: Yup.number().required("Minimum Budget is required"),
    maxBudget: Yup.number().required("Maximum Budget is required"),

    password: isRequired
      ? Yup.string()
          .required("Password is required")
          .min(8, "Password must be at least 8 characters")
          .matches(
            /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?`~])[a-zA-Z\d!@#$%^&*()_+[\]{};':"\\|,.<>/?`~]+$/,
            "Password must include letters, numbers, and at least one special character"
          )
      : Yup.string(),
    confirmPassword: isRequired
      ? Yup.string()
          .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required("Confirm Password is required")
      : Yup.string(),
  });
